
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(4(3(09|15|75)|538|658)|6(269|484|929)|16(06|7)|7(570|700|747|881|959)|3(506|564|737|977)|[29]387|842|8668)$/.test(chunkId);
},
rootOutputDir: "",

    };
}
